import { adminStats, AdminStat } from '@/mocks/admin';

function StatCard({ stat }: { stat: AdminStat }) {
  const isUp = stat.changeType === 'up';
  const isDown = stat.changeType === 'down';

  return (
    <div className="bg-surface-2 border border-white/8 rounded-xl p-6 flex flex-col gap-4 hover:border-gold/25 transition-colors duration-300">
      <div className="flex items-start justify-between">
        <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-gold/10 border border-gold/20">
          <i className={`${stat.icon} text-gold text-xl`} />
        </div>
        <span className={`flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap ${
          isUp ? 'bg-emerald-500/10 text-emerald-400' :
          isDown ? 'bg-red-500/10 text-red-400' :
          'bg-white/5 text-white/40'
        }`}>
          {isUp && <i className="ri-arrow-up-line text-xs" />}
          {isDown && <i className="ri-arrow-down-line text-xs" />}
          {stat.change}
        </span>
      </div>

      <div>
        <p className="text-white/40 text-xs font-semibold uppercase tracking-widest mb-1">
          {stat.label}
        </p>
        <p className="font-playfair text-3xl font-bold text-white">
          {stat.value}
        </p>
      </div>
    </div>
  );
}

export default function AdminStatCards() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
      {adminStats.map((stat) => (
        <StatCard key={stat.id} stat={stat} />
      ))}
    </div>
  );
}
